import PageLayout from "@common/Page";
import { COLUMN_NAME } from "@common/Page/data/columnNames";
import { IMPORT_EXPORT_TABS } from "@constant/tabs";
import {
  BRAZIL_EXPORTS,
  BRAZIL_IMPORTS,
  INDIAN_EXPORTS,
  INDIAN_IMPORTS,
  MEXICAN_EXPORTS,
  MEXICAN_IMPORTS,
} from "@features/productInsights/data/activeTabs";
import {
  getCurrentYearAndMonth,
  getMonthList,
  getYearList,
} from "@utils/helpers";
import { useState } from "react";

const currentYearAndMonth = getCurrentYearAndMonth();

const previewSelectInputFields = [COLUMN_NAME.PRODUCT];

const previewLockInputFields = [COLUMN_NAME.EXPORTER, COLUMN_NAME.IMPORTER];

export default function ImportExport() {
  const [year, setYear] = useState(currentYearAndMonth.year);
  const [month, setMonth] = useState(currentYearAndMonth.month);

  return (
    <PageLayout
      tabs={IMPORT_EXPORT_TABS}
      title={"Import & Export"}
      onMonthChange={setMonth}
      month={month}
      onYearChange={setYear}
      year={year}
      monthOptions={getMonthList()}
      yearOptions={getYearList()}
      drawerInputsToShow={["year", "month"]}
      filtersToShow={["year"]}
      useDefaultSheetNames={false}
      fetchProductsWiseData={false} // will fetch show products on contents section - true means month
      uploadUrls={{
        indian_exports: "clean-the-indian-export-raw-data",
        indian_imports: "clean-the-indian-import-raw-data",
        mexican_exports: "clean-the-mexican-export-raw-data",
        mexican_imports: "clean-the-mexican-import-raw-data",
        brazilian_exports: "clean-the-brazil-export-raw-data",
        brazilian_imports: "clean-the-brazil-import-raw-data",
      }}
      saveAndGenerateUrls={{
        indian_exports: "save-and-generate-indian-export-data",
        indian_imports: "save-and-generate-indian-import-data",
        mexican_exports: "save-and-generate-mexican-export-data",
        mexican_imports: "save-and-generate-mexican-import-data",
        brazilian_exports: "save-and-generate-brazil-export-data",
        brazilian_imports: "save-and-generate-brazil-import-data",
      }}
      redirectUrl="import_export"
      fetchRawAndFinalFileUrls={{
        indian_exports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
        indian_imports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
        mexican_imports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
        mexican_exports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
        brazilian_exports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
        brazilian_imports: {
          raw: "month-cards-imports-and-exports",
          final: "month-cards-imports-and-exports",
        },
      }}
      subTypeId={{
        indian_exports: INDIAN_EXPORTS,
        indian_imports: INDIAN_IMPORTS,
        mexican_exports: MEXICAN_EXPORTS,
        mexican_imports: MEXICAN_IMPORTS,
        brazilian_exports: BRAZIL_EXPORTS,
        brazilian_imports: BRAZIL_IMPORTS,
      }}
      sectionProductsTypes={{}}
      sectionMonthsTypes={{
        indian_exports: "indian-export",
        indian_imports: "indian-import",
        mexican_exports: "mexican-export",
        mexican_imports: "mexican-import",
        brazilian_exports: "brazil-export",
        brazilian_imports: "brazil-import",
      }}
      sectionTypeValues={{
        indian_exports: "IndianExport",
        indian_imports: "IndianImport",
        mexican_exports: "MexicanExport",
        mexican_imports: "MexicanImport",
        brazilian_exports: "BrazilianExport",
        brazilian_imports: "BrazilianImport",
      }}
      previewSelectInputFields={{
        indian_exports: previewSelectInputFields,
        indian_imports: previewSelectInputFields,
        mexican_exports: previewSelectInputFields,
        mexican_imports: previewSelectInputFields,
        brazilian_exports: previewSelectInputFields,
        brazilian_imports: previewSelectInputFields,
      }}
      previewLockInputFields={{
        indian_exports: previewLockInputFields,
        indian_imports: previewLockInputFields,
        mexican_exports: previewLockInputFields,
        mexican_imports: previewLockInputFields,
        brazilian_exports: previewLockInputFields,
        brazilian_imports: previewLockInputFields,
      }}
    />
  );
}
